import type { Schema } from '@wix/wix-data-schema-types'
import type { IndexedSchema, MaybeIndexedFields } from './types'

const sortFieldsByIndicesAndRemoveIndices = (
  schema: IndexedSchema,
): Schema => ({
  ...schema,
  fields: Object.keys(schema.fields)
    .reduce((order: string[], fieldKey) => {
      order[schema.fields[fieldKey].index] = fieldKey
      return order
    }, [])
    .reduce((newFields: MaybeIndexedFields, fieldKey) => {
      const { index, ...newField } = schema.fields[fieldKey]
      newFields[fieldKey] = newField
      return newFields
    }, {}),
})

export default sortFieldsByIndicesAndRemoveIndices
